// extracted by mini-css-extract-plugin
export default {"buildingContainer":"styles_buildingContainer__AGgCV","middleBlock":"styles_middleBlock__wn-5N","bottomBlock":"styles_bottomBlock__F2vux","rightBox":"styles_rightBox__2-4dv"};